

























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class NumericPicker extends Vue {
  @Prop() value?: number;
  @Prop({ default: 1 }) step!: number;
  @Prop({ default: "number" }) mode?: "number" | "relative";
  @Prop() rules!: [];
  @Prop({ default: false }) readonly?: boolean;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: false }) small?: boolean;
  @Prop({ default: false }) zeroEmpty?: boolean;
  @Prop() isMobile?: boolean;

  //style props
  @Prop({ default: "" }) backgroundColor?: string;

  internalModel: string | null = null;
  componentKey = 0;

  @Watch("value", { immediate: true })
  valueWatch(fresh: any) {
    this.internalModel = fresh;
    if (
      (typeof this.internalModel === "string" ||
        (!this.internalModel &&
          typeof this.internalModel == "number" &&
          isNaN(+this.internalModel))) &&
      this.mode === "number"
    ) {
      if (!this.internalModel || isNaN(+this.internalModel)) {
        this.internalModel = null;
        (this.$refs.numericBox as any).reset();
      }
    }
  }

  valueChanged() {
    if(this.zeroEmpty && (this.internalModel === "" || this.internalModel == null)) {
      this.internalModel = "0";
      this.componentKey += 1;
    }

    if (this.mode === "number") {
      this.$emit("input", this.internalModel ? +this.internalModel : null);
    } else if (this.mode === "relative") {
      this.addToInternalModel(0);
      this.$emit("input", this.internalModel);
    }
  }

  addClick() {
    if (this.readonly) {
      return;
    }

    if(!this.isMobile)
    {
      (this.$refs.numericBox as any).focus();
    }
    this.addToInternalModel(this.step);

    this.valueChanged();
  }

  subtractClick() {
    if (this.readonly) {
      return;
    }

    if(!this.isMobile)
    {
      (this.$refs.numericBox as any).focus();
    }
    this.addToInternalModel(-this.step);

    this.valueChanged();
  }

  addToInternalModel(val: number) {
    if (this.mode === "number") {
      const numeric = this.internalModel ? +this.internalModel : 0;
      if (!isNaN(numeric)) {
        this.internalModel = (numeric + val).toString();
      } else {
        this.internalModel = val.toString();
      }
    } else if (this.mode === "relative") {
      const reg = /^\s*(\+|-)?([^+-]+)$/;
      const extracted = reg.exec(this.internalModel ?? "");
      if (!extracted) {
        if (val !== 0) {
          this.internalModel = val.toString();
        }
      } else {
        const num = extracted[2] ? +extracted[2] : 0;
        const prefix = extracted[1] ?? "";
        if (isNaN(num)) {
          this.internalModel = prefix + val.toString();
        } else {
          const newVal = num + (prefix === "-" ? -val : val);
          this.internalModel = newVal === 0 ? "0" : prefix + newVal.toString();
        }
      }
    }
  }
}
